<template>
  <div v-show="show">
    <FormKit type="group" :name="name" :help-position="helpPosition" :help="field.instructions" :label="field.name" :validation="validation">
      <FormieRows :settings="settings" :rows="field.rows" />
    </FormKit>
  </div>
</template>

<script setup lang="ts">
// import Vue components used in the template manually if needed

import { fieldHelpPosition, fieldName, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  field: object // todo: we should define parentField for consistency, but it should also be checked that this must always be undefined! (Formie does not support double nesting)
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const name = fieldName(props.field)
const show = fieldVisible(props.field)
const validation = fieldValidationArray(props.field)
</script>
